import { render, staticRenderFns } from "./EditSeriesScoringConvert.vue?vue&type=template&id=0b9b33da&scoped=true"
import script from "./EditSeriesScoringConvert.vue?vue&type=script&lang=js"
export * from "./EditSeriesScoringConvert.vue?vue&type=script&lang=js"
import style0 from "./EditSeriesScoringConvert.vue?vue&type=style&index=0&id=0b9b33da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9b33da",
  null
  
)

export default component.exports